import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const Edit = (props: any) => {
  return <ExpandLessIcon {...props} />;
};

export default Edit;
